import React from "react";
import styles from "./Testimonials.module.css";
import { Reveal } from "../common/Reveal";

/* Import client images here — swap these paths for your real assets */
import client1Photo from "../../../../images/Sumit-Sarma.png";
import client2Logo from "../../../../images/LG_Logo.png";
import client3Avatar from "../../../../images/ourClient.png";

const TESTIMONIALS = [
  {
    quote:
      "Alliance Automation is always able to get things turned so quickly! Much appreciated for their work with enthusiasm. I have checked other vendors as well and they can't beat the time and service that I receive from Alliance Automation.\n\nKeep up the good work guys!!.",
    name: "Sumit Sharma, Manager SBU Process Engineering",
    org: "MINDA SAI Limited",
    variant: "photo",
    image: client1Photo,
    imageAlt: "Sumit Sharma, Manager SBU Process Engineering, MINDA SAI Limited",
  },
  {
    quote:
      "Work was executed to our entire satisfaction. We sincerely appreciate your prompt response and invaluable assistance in meeting our demands.\n\nWe wish to express our whole hearted appreciation for you & your able staff. We look forward to the continual support & promptness to service while doing business with you for years to come.",
    name: "A K Singh",
    org: "Asst. General Manager, LG Electronics",
    variant: "logo",
    image: client2Logo,
    imageAlt: "LG Electronics",
  },
  {
    quote:
      "Alliance Automation has a very talented team of professionals, they know what they are doing and ever ready to go the extra step to ensure complete satisfaction.",
    name: "Sunil Sharma, Director",
    org: "",
    variant: "plain",
    image: client3Avatar,
    imageAlt: "Our Client",
  },
];

const variantClass = {
  photo: styles.cardPhoto,
  logo: styles.cardLogo,
  plain: styles.cardPlain,
};

export default function Testimonials() {
  return (
    <section className={styles.testimonials}>
      <Reveal className={styles.sectionIntro}>
        <span className={styles.sectionLabel}>what our clients say</span>
        <h2 className={styles.sectionHeading}>Client testimonials</h2>
      </Reveal>

      <div className={styles.testimonialList}>
        {TESTIMONIALS.map((t, i) => (
          <Reveal
            key={t.name}
            delay={i * 100}
            className={`${styles.testimonialCard} ${variantClass[t.variant]} ${
              i % 2 === 1 ? styles.testimonialCardReverse : ""
            }`}
          >
            <div className={styles.testimonialQuoteWrap}>
              <span className={styles.quoteMark} aria-hidden="true">
                &ldquo;
              </span>
              <p className={styles.testimonialQuote}>{t.quote}</p>
              <p className={styles.testimonialName}>{t.name}</p>
              {t.org && <p className={styles.testimonialOrg}>{t.org}</p>}
            </div>

            <div
              className={`${styles.testimonialMedia} ${
                t.variant === "plain" ? styles.testimonialMediaPlain : ""
              }`}
            >
              <div className={styles.testimonialImageFrame}>
                <img
                  src={t.image}
                  alt={t.imageAlt}
                  className={styles.testimonialImage}
                  loading="lazy"
                />
              </div>
              {t.variant === "plain" && (
                <span className={styles.clientSignature} aria-hidden="true">
                  Our Client
                </span>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}